<template lang="html">
  <v-img
    v-if="imageUrl"
    :src="imageUrl"
    class="avatar-border-radius"
    :style="`border: 1.5px solid var(--v-${avatarBorderColor}-base);`"
  />
  <div
    v-else
    class="fill d-flex align-center justify-center"
    :style="{backgroundColor:initialsColor}"
    :class="initialsColor"
  >
    <span class="white--text font-weight-medium" :style="{'font-size': avatarInitialsFontSize}">
      <!-- TODO: fluid typography to support multiple size avatars -->
      {{ initials }}
    </span>
  </div>
</template>

<script>
import { words, join, capitalize, get, has, find } from 'lodash';

export default {
  props: {
    object: {
      type: Object,
      default: () => {},
    },
    thumbnailPath: {
      type: String,
      default: undefined,
    },
    objectKeyForInitials: {
      type: String,
      default: 'name',
    },
    text: {
      type: String,
      default: '',
    },
    profile: {
      type: Boolean,
      default: false,
    },
    oneInitialCharacter: {
      type: Boolean,
      default: false,
    },
    twoInitialCharacters: {
      type: Boolean,
      default: true,
    },
    avatarBorderColor: {
      type: String,
      default: 'avatarBorder',
    },
    smallInitials: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    avatarInitialsFontSize() {
      if (this.smallInitials) {
        return '10px';
      }
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return '14px';
        case 'md':
        case 'lg':
        case 'xl':
          return '15px';
        default:
          return '15px';
      }
    },
    initialsColor() {
      var color = '';
      if (this.profile) {
        color = 'var(--v-secondary-base) !important';
      } else {
        color = this.getColorForIndex(this.object?.id);
      }
      return color;
    },
    imageUrl() {
      if (this.thumbnailPath) {
        return this.thumbnailPath;
      } else if (this.object) {
        return this.object?.thumbnailPath || get(this.deepSearch(this.object, 'thumbnailPath'), 'thumbnailPath');
      } else {
        return null;
      }
    },
    initials() {
      if (this.object) {
        var str = get(this.object, this.objectKeyForInitials);
        if (str == '' || str == undefined) {
          str = this.text;
        }

        if (this.oneInitialCharacter) {
          var charToUpperCase = str.charAt(0) || this.text.charAt(0) || '';
          return charToUpperCase.toUpperCase();
        }

        if (this.twoInitialCharacters) {
         var parts = words(str);

          if (!this.imageUrl && parts.length >= 2) {
            return parts.slice(0, 2).map(part => part.charAt(0).toUpperCase()).join('');
          }
        }
        //capitalize first letter to show initials
        if (str[0]?.toUpperCase() !== str[0]) {
          str = capitalize(str);
        }

        return this.toInitials(str);
      } else {
        return this.text;
      }
    },
  },
  methods: {
    get,
    capitalize,
    hasUpperCase(str) {
      return str.toLowerCase() != str;
    },
    toInitials(val) {
      return join(
        words(val).map(v => (v[0].match(/[A-Zvd]/) ? v[0] : '')),
        ''
      );
    },
    getColorForIndex(index) {
      let { colorWheelDashboardTiles } = this.$root.theme;
      if (!colorWheelDashboardTiles) return undefined;
      return colorWheelDashboardTiles[Number.parseInt(index) % colorWheelDashboardTiles.length];
    },
    // Helper method to recursively search key in object
    deepSearch(obj, key) {
      if (has(obj, key)) {
        return obj;
      }

      return find(obj, (v) => {
        return typeof v === 'object' && this.deepSearch(v, key);
      });
    },
  },
};
</script>
<style scoped lang="css">
.avatar-border-radius {
  border-radius: 50px;
}
</style>